module.exports = __webpack_public_path__ + "media/images/search-gray-7aca26b0fb64146727a63b6f3e82a786.svg";